<template>
    <div class="form-field-select">
        <label :for="id" :class="labelClasses">{{ label }}</label>
        <div class="mt-2.5 relative">
            <button type="button" :id="id" :class="inputClasses" @click="toggleDropdown" @blur="handleBlur">
                <span v-if="selectedText" class="block truncate text-left">{{ selectedText }}</span>
                <span v-else class="block truncate text-left text-gray-400">{{ placeholder }}</span>
                <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                    <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                        <path
                            fill-rule="evenodd"
                            d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </span>
            </button>
            <div v-if="isOpen" class="absolute z-10 mt-1 w-full rounded-md bg-white shadow-lg ring-1 ring-black/5">
                <ul class="max-h-60 rounded-md py-1 text-base overflow-auto focus:outline-hidden sm:text-sm">
                    <li
                        v-for="item in items"
                        :key="getItemValue(item)"
                        class="relative cursor-pointer select-none py-2.5 px-4 hover:bg-gray-100"
                        :class="{'bg-sky-50 text-sky-900': getItemValue(item) === value}"
                        @mousedown="selectItem(item)"
                    >
                        {{ getItemText(item) }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormFieldSelect',
    props: {
        id: {
            required: false,
            type: String,
            default: null,
        },
        label: {
            required: false,
            type: String,
            default: null,
        },
        field: {
            required: false,
            type: String,
            default: null,
        },
        value: {
            required: false,
            type: [String, Number],
            default: null,
        },
        placeholder: {
            required: false,
            type: String,
            default: null,
        },
        items: {
            required: true,
            type: Array,
            default: () => [],
        },
        itemText: {
            required: false,
            type: String,
            default: 'text',
        },
        itemValue: {
            required: false,
            type: String,
            default: 'value',
        },
    },
    data() {
        return {
            isOpen: false,
        };
    },
    computed: {
        selectedText() {
            if (this.value === null || this.value === undefined) return null;
            const selectedItem = this.items.find((item) => this.getItemValue(item) === this.value);
            return selectedItem ? this.getItemText(selectedItem) : null;
        },
        labelClasses() {
            const cls = {};
            cls['text-md block font-medium leading-6 text-gray-900'] = true;
            return cls;
        },
        inputClasses() {
            const cls = {};
            cls['relative block w-full rounded-md border-0 px-4 py-2.5 pr-10 shadow-xs'] = true;
            cls['sm:text-sm sm:leading-6'] = true;
            cls['text-gray-900'] = true;
            cls['ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-sky-600'] = true;
            cls['text-left bg-white'] = true;
            return cls;
        },
    },
    methods: {
        getItemText(item) {
            if (typeof item === 'object' && item !== null) {
                return item[this.itemText];
            }
            return item;
        },
        getItemValue(item) {
            if (typeof item === 'object' && item !== null) {
                return item[this.itemValue];
            }
            return item;
        },
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        handleBlur() {
            // Delay closing to allow click events on items
            setTimeout(() => {
                this.isOpen = false;
            }, 200);
        },
        selectItem(item) {
            const newValue = this.getItemValue(item);
            this.$emit('update', {field: this.field, value: newValue});
            this.$emit('focused', {field: this.field, value: newValue});
            this.isOpen = false;
        },
    },
};
</script>
